import { RouteRecordRaw } from 'vue-router'

const secondPartnerRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/event-submission-tool',
  },
  {
    path: '/event-submission-tool',
    name: 'event-submission-tool',
    component: () => import('@/layouts/index.vue'),
    meta: {
      title: '活动提报工具',
      icon: 'Document',
    },
    children: [
      {
        path: '',
        component: () => import('@/views/CompanyManagement/EventSubmissionTool/index.vue'),
        meta: {
          title: '活动提报工具',
          hidden: true,
        },
      },
    ],
  },
  {
    path: '/corporate-event-management',
    name: 'corporate-event-management',
    component: () => import('@/layouts/index.vue'),
    meta: {
      title: '公司活动管理',
      icon: 'Management',
    },
    children: [
      {
        path: '',
        component: () => import('@/views/CompanyManagement/CorporateEventManagement/index.vue'),
        meta: {
          title: '公司活动管理',
          hidden: true,
        },
      },
    ],
  },
]

export default secondPartnerRoutes
